import React, { useState, useEffect } from 'react';
import './TrainList.css';
import TrainSharpIcon from '@mui/icons-material/TrainSharp';
import trainss from './train.png';
import axios from 'axios';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import Spinner from '../Spinner';
const TrainDetail = () => {
  const [isRouteVisible, setIsRouteVisible] = useState(false);
  const [trainData, setTrainData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const toggleRouteVisibility = () => {
    setIsRouteVisible(!isRouteVisible);
  };
  const [date, setDate] = useState("7-07-2023");
  const location = useLocation();
  const data = location.state;
  console.log(data)
  const fetchData = async () => {
    const proxyUrl = 'https://toureila.onrender.com';
    const endpoint = '/trains/gettrainon';
    const from = data.from;
    const to = data.to;
    const date = data.departure_date;
  
    try {
      const response = await axios.get(`${proxyUrl}${endpoint}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          from,
          to,
          date
        }
      });
  
      if (response.data && response.data.data) {
        setTrainData(response.data.data);
        setIsLoading(false);
      } else {
        setTrainData([]); 

      }
      console.log(response.data.data);


    } catch (error) {
      console.error(error);
      setTrainData([]);
      setIsLoading(false);
    }
  };

  // console.log(trainData);
  // const fetchData = async () => {
  //   const options = {
  //     method: 'GET',
  //     url: 'https://irctc1.p.rapidapi.com/api/v3/trainBetweenStations',
  //     params: {
  //       fromStationCode: 'BVI',
  //       toStationCode: 'NDLS',
  //       dateOfJourney: '2023-07-05',
  //     },
  //     headers: {
  //       'X-RapidAPI-Key': '3a281bf59fmsh2bf606e20492079p16c178jsn5f27879e70ef',
  //       'X-RapidAPI-Host': 'irctc1.p.rapidapi.com',
  //     },
  //   };

  //   try {
  //     const response = await axios.request(options);
  //     setTrainData(response.data.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const formatDuration = (duration) => {
    // Check if the duration is in the expected format
    if (!duration.includes('.')) {
      return 'Invalid duration';
    }
  
    const [hours, minutes] = duration.split('.');
    const totalMinutes = parseInt(hours) * 60 + parseInt(minutes);
  
    const formattedHours = Math.floor(totalMinutes / 60);
    const formattedMinutes = totalMinutes % 60;
  
    return `${formattedHours} hours ${formattedMinutes} minutes`;
  };
  useEffect(() => {
    fetchData();
  }, []);
  const getRunningDaysAbbreviation = (runningDays) => {
    const daysOfWeek = ['M', 'T', 'W', 'T', 'F', 'S','S'];
  
    return daysOfWeek
      .map((day, index) => (runningDays[index] === '1' ? day : ''))
      .join('');
  };
  const formatTime = (time) => {
    const [hours, minutes] = time.split('.');
    return moment(`${hours}:${minutes}`, 'H:mm').format('h:mm A');
  };

  const formatDay = (date) => {
    return moment(date, 'DD-MM-YYYY').format('ddd');
  };
  const calculateDestinationTime = (fromTime, duration) => {
    const [fromHours, fromMinutes] = fromTime.split(':');
    const [durationHours, durationMinutes] = duration.split('.');

    const totalHours = parseInt(fromHours) + parseInt(durationHours);
    const totalMinutes = parseInt(fromMinutes) + parseInt(durationMinutes);

    const destinationTime = moment(date, 'DD-MM-YYYY')
      .add(totalHours, 'hours')
      .add(totalMinutes, 'minutes')
      .format('hh:mm A');

    return destinationTime;
  };
  const handleSubmit = (trainNo) => {
    const { from, to } = data;
  
    const url = `https://www.ixigo.com/trains/${trainNo}?orgn=${from}&dstn=${to}&departDate=${data.departure_date}&quota=GN`;
    window.location.href = url;
  };

  if (isLoading) {
    return <Spinner />;
  }
  


  return (
<div className="container">
{trainData === "No direct trains found" ? (
     <center> <h1>No direct trains found</h1></center>
    ) : (
      <React.Fragment>


      { trainData.map((train, index) => (
        <div className="card train-card" key={index}>
          <div className="">
            <img src={trainss} alt="" width="76px" height="80px" />
            <div className="">
              <h5 className="card-title ccd">{train.train_base?.train_name}</h5>
              <div className="train-depart-number ccd">
                <span>{train.train_base.train_no}  </span>
                <span>|</span>
                <span>
                  Departs on: 
                  <span className="green">
                  {train && train.train_base.running_days && (
  <span className="green">
    <b>{getRunningDaysAbbreviation(train.train_base.running_days)}</b>
  </span>
)}
</span>
                </span>
              </div>
              <div className="departure-date ccd">{date}</div>
              <div className="card-text ">
               
                <div className="train-info cad">
                  <div className="left-info">
                    <div className="depart-time mt-3 leftt">{formatTime(train.train_base.from_time)}, {formatDay(date)}</div>
                    <div className="station-name leftt">{train.train_base.from_stn_name}</div>
                    
                  </div>
                  <div className="route-details">
                    <div className="jouney-duration">
                      <span className="jouney-duration-line" />
                      <span className="duration">
                      <b>{formatDuration(train.train_base.travel_time)}</b>
                      </span>
                      <span className="jouney-duration-line" />
                    </div>
                  </div>
                  <div className="right-info">
                 
                    {/* <div className={`view-routes ${isRouteVisible ? 'active' : ''}`} onClick={toggleRouteVisibility}>
                      {isRouteVisible ? 'Hide route' : 'View route'}
                    </div> */}
                    {/* {isRouteVisible && (
                      <div className="route-details">
                        {/* Add route details here 
                      </div>
                    )} */}
                    {/* <div className="">
                    
                    </div> */}

                    <div className="arrival-time rightt">{calculateDestinationTime(train.train_base.from_time, train.train_base.travel_time)}</div>
                    <div className="station-name rightt">{train.train_base.to_stn_name}</div>
                    
                  </div>
                </div>
              </div>
              <button className="btn btn-primary align-top-right" onClick={() => handleSubmit(train.train_base.train_no)}>
  Check Availability
</button>
            </div>
          </div>
        </div>
      ))}
      </React.Fragment>
      )
   
  }
    </div>
  );
};

export default TrainDetail;


// import React from 'react';
// import moment from 'moment';
// import './TrainList.css';
// const trainData = [
//     { id: 1, name: 'Train A', from: 'City X', destination: 'City Y', departureDate: '2023-07-05', arrivalDate: '2023-07-06', duration: '10h 30m', trainNo: 'ABC123', departureTime: '09:00 AM' },
//     { id: 2, name: 'Train B', from: 'City P', destination: 'City Q', departureDate: '2023-07-07', arrivalDate: '2023-07-08', duration: '8h 45m', trainNo: 'DEF456', departureTime: '11:30 AM' },
//     { id: 3, name: 'Train C', from: 'City M', destination: 'City N', departureDate: '2023-07-09', arrivalDate: '2023-07-10', duration: '12h 15m', trainNo: 'GHI789', departureTime: '02:15 PM' },
// ];
// function TrainList() {
//     return (
//        <div className="container" > <div className="card w-70 mb-3 mt-5 p-5">
//             <div className="card-body">
//                 <h5 className="card-title">Card title</h5>
//                 <p className="card-text">With supporting text below as a natural lead-in to additional content.</p>
                
//             </div>
//         </div></div>
        // <div className="train-list">
        //   {trainData.map((train, index) => (
        //     <div className="train-card" key={index}>
        //       <div className="train-card__header">

        //         <h2 className="train-card__name">{train.name}</h2>
        //       </div>
        //       <div className="train-card__details">
        //         <p className="train-card__departure">{moment(train.departureTime).format('hh:mm A')}</p>
        //         <div className="train-card__route" />
        //         <p className="train-card__arrival">{moment(train.arrivalTime).format('hh:mm A')}</p>
        //       </div>
        //       <div className="train-card__footer">
        //         <p className="train-card__duration">{train.duration}</p>
        //         <p className="train-card__price">{train.price}</p>
        //         <button className="train-card__button">Book Now</button>
        //       </div>
        //     </div>
        //   ))}
        // </div>
//     );
// }

// export default TrainList;
